import { useEffect } from 'react';
import { Scale } from 'lucide-react';
import { LoadingState, ErrorState } from '../../components/LoadingState';
import { useGenerateRegulation } from '../../api/queries';
import styles from './RegulationView.module.css';

type LawEntry = {
  title: string;
  reference?: string;
  scope?: string;
  relevance?: string;
  key_points?: string;
};

export function RegulationView() {
  const mut = useGenerateRegulation();
  useEffect(() => {
    if (!mut.data && !mut.isPending && !mut.error) mut.mutate({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (mut.isPending) return <LoadingState label="Recopilando normativa…" />;
  if (mut.error) return <ErrorState error={mut.error} onRetry={() => mut.mutate({})} />;
  const data = mut.data as any;
  if (!data) return null;

  const framework = data.content?.legal_framework ?? {};
  const groups: Array<{ label: string; items: LawEntry[] }> = [
    { label: 'Legislación', items: framework.legislation ?? [] },
    { label: 'Normativa', items: framework.regulations ?? [] }
  ].filter((g) => g.items.length > 0);

  if (groups.length === 0) {
    return (
      <div className={styles.empty}>
        <Scale size={28} />
        <p>No hay marco legal específico para este módulo.</p>
      </div>
    );
  }

  return (
    <div className={styles.view}>
      {groups.map((g) => (
        <section key={g.label} className={styles.group}>
          <h3 className={styles.groupTitle}>{g.label}</h3>
          <ul className={styles.list}>
            {g.items.map((it, i) => (
              <li key={i} className={styles.item}>
                <h4 className={styles.itemTitle}>{it.title}</h4>
                {it.reference && (
                  <p className={styles.ref}>{it.reference}{it.scope ? ` · ${it.scope}` : ''}</p>
                )}
                {(it.relevance || it.key_points) && (
                  <p className={styles.body}>{it.relevance ?? it.key_points}</p>
                )}
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
